<style lang="scss" src='./Dashboard.scss' scoped ></style>
<template src="./Dashboard.html"></template>

<script>
import { mapState, mapActions, mapMutations } from "vuex";
import CommonComponent from "@/components/utils/CommonComponent.vue";
import { Hooper, Navigation as HooperNavigation } from "hooper";
import "hooper/dist/hooper.css";
import VuePullRefresh from "vue-pull-refresh";
import WeatherWidget from "@/components/weather/WeatherWidget.vue";
import WeatherInfo from "@/components/weatherInfo/WeatherInfo.vue";
import { Carousel, Slide } from "vue-carousel";
import { isEmpty } from "lodash";

export default {
  name: "Dashboard",
  extends: CommonComponent,
  components: {
    Hooper,
    Carousel,
    Slide,
    HooperNavigation,
    WeatherWidget,
    WeatherInfo,
    "vue-pull-refresh": VuePullRefresh,
  },
  data() {
    return {
      maxListHeight: 600,
      alertUpdateInterval: null,
      maxHeightDashboard: 600,
      extraParamText: null,
      extraParamValue: null
    };
  },
  computed: {
    ...mapState("Dashboard", {
      localWeather: (state) => state.localWeather,
      microWeather: (state) => state.microWeather,
      weatherPrecipitation: (state) => state.weatherPrecipitation,
      alerts: (state) => state.alerts,
      alertsDashboard: (state) => state.alertsDashboard,
      tasksDashboard: (state) => state.tasksDashboard,
      recentComments: (state) => state.recentComments,
      loading: (state) => state.loading,
      showClimate: (state) => state.showClimate,
      dailyTemps: (state) => state.dailyTemps,
    }),

    checkLocalWeather() {
      if (!isEmpty(this.localWeather) && this.localWeather && this.localWeather.icon_code) {
        return true;
      }
      return false;
    },

    checkMicroWeather(){
      if(this.microWeather && this.microWeather.length > 0){
        return true
      }
      return false;
    },
  },
  watch: {
    course() {
      this.loadData();
    },
  },
  methods: {
    changeView() {
      this.setShowClimate(!this.showClimate);
    },

    goToAlert(type) {
      this.$router.push({
        name: 'Alerts',
        params: { type },
      });
    },

    goToTask(type, task) {
      this.$router.push({
        name: "TaskBoard",
        params: { taskId: task ? `${task.task_id}` : null, tab: type },
      });
    },

    loadData(){
      this.loadWeather();
      this.loadAlertsDashboard();
      this.loadTasksDashboard();
      this.loadRecentCommentsDashboard();
      this.loadMinMaxTempsWeather();
      
      let objKeys = Object.keys(this.alertsDashboard.all_alerts)
      let firstAttribute = objKeys[0];

      if (firstAttribute == this.consts.AlertType.ET_RATE.id) {
        firstAttribute = objKeys[1];
      }

      if(firstAttribute){
        this.extraParamText  = firstAttribute  
      }
    },

    ...mapActions("Dashboard", [
      "loadWeather",
      "loadAlerts",
      "loadAlertsDashboard",
      "loadTasksDashboard",
      "loadRecentCommentsDashboard",
      "loadMinMaxTempsWeather",
    ]),
    ...mapMutations("Dashboard", ["setSelectedAlert", "setShowClimate"]),
  },

  beforeCreate() {},

  created() {},

  beforeMount() {
    this.setShowMenu(true);
    this.setShowBackground(true);
  },

  mounted() {
    this.loadData();
  },

  beforeDestroy() {
    this.setShowClimate(false);
    window.clearInterval(this.alertUpdateInterval);
  },
};
</script>
